import type { WorldRegion } from "../../config/worldRegionsConfig";
import type { TimeStepsSet } from "../../data/hooks/types";
import type { W3Product } from "./types/data";

export function combineW3Products(
    worldRegion: WorldRegion,
    nearcastW3TileSet: W3Product | undefined,
    forecastW3TileSet?: W3Product,
) {
    // if current data is not loaded yet, ignore fetching of forecast data because we want at least current data to be displayed and not forecast data only
    if (nearcastW3TileSet === undefined) {
        return undefined;
    }

    const nearcastTimeSteps = nearcastW3TileSet.timeSteps;
    const forecastTimeSteps = forecastW3TileSet?.timeSteps ?? [];

    const timeStepsSet: TimeStepsSet = {
        nearcast: {
            productName: nearcastW3TileSet.productName,
            run: nearcastW3TileSet.run,
            bounds: nearcastW3TileSet.bounds,
            timeSteps: nearcastTimeSteps,
            worldRegion,
            intensityBarApiUrlTemplate:
                nearcastW3TileSet.intensityBarApiUrlTemplate,
            ...(nearcastW3TileSet.debug.source !== undefined
                ? { source: nearcastW3TileSet.debug.source }
                : {}),
            ...(nearcastW3TileSet.dataTemporaryNotAvailableVectorTilesUrlTemplate !==
            undefined
                ? {
                      dataTemporaryNotAvailableVectorTilesUrlTemplate:
                          nearcastW3TileSet.dataTemporaryNotAvailableVectorTilesUrlTemplate,
                  }
                : {}),
        },
    };

    if (forecastW3TileSet && forecastTimeSteps.length > 0) {
        timeStepsSet.forecast = {
            productName: forecastW3TileSet.productName,
            run: forecastW3TileSet.run,
            bounds: forecastW3TileSet.bounds,
            worldRegion,
            intensityBarApiUrlTemplate:
                forecastW3TileSet.intensityBarApiUrlTemplate,
            timeSteps: forecastTimeSteps,
            ...(nearcastW3TileSet.debug.source !== undefined
                ? { source: nearcastW3TileSet.debug.source }
                : {}),
        };
    }

    return timeStepsSet;
}
